import { Component, OnInit, HostListener, EventEmitter, ViewChild, ElementRef, } from '@angular/core';
import { MaterializeAction } from 'angular2-materialize';

import { DomSanitizer, SafeResourceUrl, } from '@angular/platform-browser';
import { AppService } from '../app.service';
import { LookupList, ILookup } from '../shared/lookup';
import { MessageBrokerService } from '../shared/core/message-broker.service';
import { ProjectItem } from '../project/index';
import { IReportItem } from './reports-Item.model';
import { ReportsService } from './reports.service';
import { ReportBuilder } from './reports-builder.model';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { SharedUtils, DateUtils } from '../shared/utils';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { ISubscription } from 'rxjs/Subscription';
import { NotificationsService, Notification } from '../shared/helper-components/index';
import { PromptOptions, ModalPromptService } from '../shared/helper-components/modal-prompt.service';
import { ClearanceItemTagComponent } from '../clearance-item';
import { CITag } from '../clearance-item/clearance-item.model';
import { FormGroup } from '../../../node_modules/@angular/forms';
import { FileDownloadService } from '../shared/helper-components/file-download.service';
import { Http } from '@angular/http';
import { AuthService } from '../shared/core/index';

declare var Materialize: any;

@Component({
    selector: 'reports',
    template: require('./reports.component.html')

})
export class ReportsComponent implements OnInit, OnDestroy {

    @ViewChild('maincontainer') public maincontainer: ElementRef;
    @ViewChild('filterTagsCheck') filterTagsCheck:ElementRef;
    @ViewChild('tagComponent') tagComponent: ClearanceItemTagComponent;

    private projectChangesSubscription: ISubscription;

    showSpinner: boolean;
    content: SafeResourceUrl;
    reportParams: ReportBuilder;
    statusLookup: ILookup[] = [];
    restrictionsLookup: ILookup[] = [];
    isLoadingMoreRecords: boolean = false;
    reportItemMessage: string;
    reportItemMessageTitle: string;
    modalActions = new EventEmitter<string | MaterializeAction>();
    includeAllTags: boolean = false;
    globalTags: CITag[] = [];

    MASTER_REPORT_NAME = 'masterReport';
    MASTER_REFERENCE_REPORT_NAME = 'masterReferenceReport';
    END_CREDITS_REPORT_NAME = 'endCreditsReport';
    objectKeys = Object.keys;
    reports: { [type: string]: string } = {
        masterReport: 'Master',
        masterReferenceReport: 'Master With Reference',
        endCreditsReport: 'Distribution Memos'
    };
    REPORT_GENERATED_SUCCESSFULLY = 1;
    REPORT_GENERATION_IN_PROGRESS = 0;
    REPORT_WITH_ERROR = -1;
    filterMaterializeActions = new EventEmitter<string | MaterializeAction>();
    modelParams = [
        {
            dismissible: false
        }
    ]

    constructor(
        private _appService: AppService, public sanitizer: DomSanitizer,
        private _messageBrokerService: MessageBrokerService,
        private _reportService: ReportsService,
        private _errorHandler: GlobalErrorHandler,
        private _prompt: ModalPromptService,
        private _notificationsService: NotificationsService,
        private _fileDownloadService: FileDownloadService,
        private _http: Http,
        private _authService: AuthService,) {
    }
    public ngOnInit() {
        //console.log(`Reports: ${ JSON.stringify(this.reports)}: ${Object.keys(this.reports)[0]}` );

        this.reportParams = new ReportBuilder();
        this.reportParams.reportName = Object.keys(this.reports)[0];
        this.reportParams.restrictionType = 'Notes';
        this.reportParams.sortedBy = '';
        this.reportParams.status = 'All';
        this.reportParams.sortDirection = 'ASC';
        this.reportParams.searchBy = 'All';
        this.reportParams.searchByValue = '';
        this.reportParams.reports = [];
        this.reportParams.pageSize = 10;
        this.reportParams.pageStartIndex = 1;
        this.reportParams.includeTheseTags = [];
        this.reportParams.excludeTheseTags = [];
        this.reportParams.isCustomHeaderSelected=false;
        this.reportParams.customHeader='';
        this.reportParams.asOfDate=null;
        this.reportParams.asOfDate=null;
        this.reportParams.reports = new Array<IReportItem>();     
        this.subScribeProjectNameChanges();

        this.initMaterial();
        $('.tooltipped').tooltip({ delay: 50 });

    }
    ngOnDestroy() {
        this.projectChangesSubscription.unsubscribe();
    }
    ngAfterViewInit() {
        $('.tooltipped').tooltip({ delay: 50 });
        SharedUtils.RemoveTooltipIfNeeded();
        $('.collapsible').collapsible();
        if (SharedUtils.IsMobile()) {

            this.openFirst();
            setTimeout(() => {
                this.closeFirst();
            }, 1500);
        }
        SharedUtils.FixFlickering();
    }

    get IsMobile(){
        return SharedUtils.IsMobile();
    }

    openFirst() {
        this.filterMaterializeActions.emit({ action: "collapsible", params: ['open', 0] });
    }

    closeFirst() {
        this.filterMaterializeActions.emit({ action: "collapsible", params: ['close', 0] });
    }
    subScribeProjectNameChanges(): void {
        this.projectChangesSubscription = this._messageBrokerService.getCurrentProject().subscribe((project: ProjectItem) => {
            if (project != null && project.ProjectId) {
                let openedProject = project;
                this.reportParams.projectId = project.ProjectId;
                this.loadCILookups(project.ProjectId);
                this.refreshReportsList();
            }
        });
    }


    @HostListener("window:scroll", ["$event"])
    public onWindowScroll() {
        let pos = document.body.scrollTop + document.documentElement.clientHeight;
        if (pos >= document.documentElement.scrollHeight) {
            //code when scroll reached end
            this.loadMoreRecords();
        }
    }

    moreRecords(): boolean {
        if (!this.isLoadingMoreRecords && !this.reportParams) {
            let nextPageRecordStartIndex = this.reportParams.pageSize + this.reportParams.pageStartIndex;
            return this.reportParams.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000;
        }

        return false;
    }

    manualLoad(): void {
        this.loadMoreRecords();
        setTimeout(() => {
            this.maincontainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        });
    }

    loadMoreRecords(): void {
        if (!this.isLoadingMoreRecords) {
            let nextPageRecordStartIndex = this.reportParams.pageSize + this.reportParams.pageStartIndex;
            //if there are more records to fetch
            if (this.reportParams.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000) {
                this.isLoadingMoreRecords = true;
                this.reportParams.pageStartIndex = nextPageRecordStartIndex;
                var reportGenerateParams = this.getRequestParams();
                this._reportService.getReportsList(reportGenerateParams)
                    .subscribe(
                        (data) => {
                            this.isLoadingMoreRecords = false;
                            if (data.reports) {
                                this.reportParams.totalNumberOfRecords = data.totalNumberOfRecords;
                                this.reportParams.pageStartIndex = data.pageStartIndex;
                                data.reports.forEach(it => this.reportParams.reports.push(it));

                                console.log(this.reportParams.reports.length);
                            }

                        },
                        (error: any) => {
                            this.processError(error);
                        }
                    );

            }

        }
    }
    processError(error: any) {
        this.isLoadingMoreRecords = false;
        if (error.status == 404) {

        } else {
            this._errorHandler.processError(error);
        }
    }

    generateReports() {
        window.scrollTo(0, 0);
        
        this.showSpinner = true;        
        var reportGenerateParams = this.getRequestParams();
        /*if(reportGenerateParams.isCustomHeaderSelected && reportGenerateParams.customHeader)
        {
            reportGenerateParams.customHeader=reportGenerateParams.customHeader.split('\n').join('<br>');
        }*/
        this._reportService.generateReports(reportGenerateParams)
            .subscribe(
                (res) => {
                    console.log('queued: ' + res);
                    this.refreshReportsList();
                    this._notificationsService.add(new Notification('success', 'Your report has been submitted for processing, please check the status below or hit the refresh button to update its status'));
                    this.showSpinner = false;
                },
                (error: any) => {
                    var e = JSON.stringify(error);

                        if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
                            this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));
                        }
                        else{
                            this.processError(error);
                        }
                }
            );

    }
    refreshReportsList() {
        this.showSpinner = true;
        var reportGenerateParams = this.getRequestParams();
        this._reportService.getReportsList(reportGenerateParams)
            .subscribe(
                (res) => {
                    this.reportParams.reports = [];
                    // console.log('reports list: ' + JSON.stringify(res));
                    this.reportParams.pageStartIndex = res.pageStartIndex;
                    this.reportParams.pageSize = res.pageSize;
                    this.reportParams.totalNumberOfRecords = res.totalNumberOfRecords;
                    if(res.reportPrivilegedNotes && res.reportPrivilegedNotes.length>0)
                    {
                        this.reportParams.isCustomHeaderSelected=true;
                        this.reportParams.customHeader=res.reportPrivilegedNotes.split('<br>').join('\n');
                        if(!this.reportParams.asOfDate)
                            this.reportParams.asOfDate=(new Date()).toDateString();
                    }
                    res.reports.forEach(it => {
                        it.toolTipSearchByDelay = 5000;
                        it.toolTipStatusDelay = 5000;
                        this.reportParams.reports.push(it)
                    });
                    this.showSpinner = false;
                    this.initMaterial();
                    $('.tooltipped').tooltip({ delay: 50 });
                },
                (error: any) => {
                    this.reportParams.reports = [];
                    this.processError(error);
                }
            );
    }

    getReport(item: IReportItem): void {
        var self = this;
        this.showSpinner = true;
        var reportGenerateParams = this.getRequestParams();
        reportGenerateParams.reportId = item.reportId;
        this._reportService.getReportsItem(reportGenerateParams)
            .subscribe(
                (res) => {
                    this._http.get(res.reportUrl, { responseType: 3 })
                    .map(response => response.blob())
                    .subscribe(
                        (blob: Blob) => {
                        this._fileDownloadService.downloadFile(blob, this.getReportFileName(res));
                        },
                        (error) => {
                            this.processError(error);
                        }
                    );
                },
                (error: any) => {
                    this.processError(error);
                }
            );

    }

    getReportFileName(item: IReportItem): string{
        switch(item.reportName) { 
            case "masterReport": { 
                return item.projectName + "_Master_" + item.status + ".pdf";
            } 
            case "masterReferenceReport": { 
                return item.projectName + "_Master With Reference_" + item.status + ".pdf";
            }
            case "endCreditsReport": { 
                return item.projectName + "_Distribution Memos_" + item.restrictionType + ".pdf";
            } 
            default: { 
                return item.projectName + "_" + item.reportName + ".pdf";
            }
        }
    }


    getRequestParams(): ReportBuilder {
        var reportGenerateParams = <ReportBuilder>Object.assign({}, this.reportParams);
        if (!reportGenerateParams.searchByValue)
            reportGenerateParams.searchBy = 'All';

        reportGenerateParams.reports = [];
        if(reportGenerateParams.asOfDate)
            reportGenerateParams.asOfDate=new Date(reportGenerateParams.asOfDate).toISOString().split('T')[0];

        //to minimize the payload send only either selected or unselected (service should be able to figure it out)
        if (this.tagComponent && (this.filterTagsCheck && this.filterTagsCheck.nativeElement.checked) ) {
           
            let selectedTags = this.tagComponent.getSelectedTags();
            var selectedItems = [];
            if(selectedTags.length > 0){
                selectedItems = selectedTags.map(t => t.tagId);
            }
           
            var unselectedTags =[];
            unselectedTags = this.tagComponent.globalTags.filter(t => {
                return !selectedItems.find(s => s == t.tagId);
            });

            let allTagsCount = this.tagComponent.globalTags.length;
            if (unselectedTags.length != allTagsCount && selectedTags.length != allTagsCount ) {
                if (unselectedTags.length > selectedItems.length)
                    reportGenerateParams.includeTheseTags = selectedItems;//.map(s=> `'${s}'`).join(',');        
                else
                    reportGenerateParams.excludeTheseTags = unselectedTags.map(ut => ut.tagId);// `'${ut.tagId}'`).join(',');
            }
        }

        return reportGenerateParams;
    }

    reportItemClicked(item: IReportItem): void {
        this.reportItemMessage = '';
        this.reportItemMessageTitle = '';
        if (item.reportStatus == this.REPORT_GENERATED_SUCCESSFULLY) {
            this.getReport(item);
        }
        else if (item.reportStatus == this.REPORT_WITH_ERROR || item.errorMessage) {
            this.reportItemMessage = item.errorMessage;
            this.reportItemMessageTitle = 'Error';
            this.modalActions.emit({ action: "modal", params: ['open'] });
        }
        else {
            this.reportItemMessage = 'The system is generating the report, please click on the Refresh button.';
            this.reportItemMessageTitle = 'In Progress';
            this.modalActions.emit({ action: "modal", params: ['open'] });
        }
    }
    closeModal() {
        this.modalActions.emit({ action: "modal", params: ['close'] });
    }

    clearParameters() {
        this.reportParams.sortedBy = '';
        this.reportParams.sortDirection = 'DESC';
        this.reportParams.searchByValue = '';


        this.reportParams.status = this.statusLookup[0].id;
        this.reportParams.restrictionType = this.restrictionsLookup[0].name;
        this.reportParams.searchBy = 'All';
        this.reportParams.isCustomHeaderSelected=false;
        this.reportParams.customHeader='';
    }

    filterChanged(filterType: string): void {
        window.scrollTo(0, 0);

        if (filterType == 'clear') {
            this.reportParams.searchByValue = '';
            this.reportParams.searchBy = 'All';
        }
        if (filterType == 'searchBy') {
            if (this.reportParams.searchBy == 'All')
                this.reportParams.searchByValue = '';
        }
    }

    initMaterial() {
        Materialize.updateTextFields();
    }

    loadCILookups(projectId: string): void {
        this._appService.retrieveCILookups('CIStatus,CIRestrictions', projectId)
            .subscribe(
                (list) => {
                    if (list) {
                        this.onLookupsRetrieved(list);
                    }
                },
                (error) => {

                }
            );

    }
    onLookupsRetrieved(list: LookupList[]): void {
        if (list && list.length > 0) {
            this.statusLookup = [];
            this.restrictionsLookup = [];

            if (list.find(it => it.lookupType == 'CIStatus') != null && list.find(it => it.lookupType == 'CIStatus').lookupData) {
                list.find(it => it.lookupType == 'CIStatus').lookupData.forEach(look => this.statusLookup.push(look));
                
                let firstLookup = new ILookup('All', 'All');
                this.statusLookup.splice(0, 0, firstLookup);

                let staticLookup;
                if(!this._authService.secondApproval){
                    staticLookup = new ILookup('Urgent', 'Urgent');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Pending', 'All Pending');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Clear', 'All Clear');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                }
            }
            if (list.find(it => it.lookupType == 'CIRestrictions') != null && list.find(it => it.lookupType == 'CIRestrictions').lookupData) {
                list.find(it => it.lookupType == 'CIRestrictions').lookupData.forEach(look => this.restrictionsLookup.push(look));
                this.reportParams.restrictionType = this.restrictionsLookup[0].name;
            }
        }

    }

    deleteReportClicked(item: IReportItem): void {
        this._reportService.deleteReport(item.reportId)
            .subscribe(
                (r) => {
                    var index = this.reportParams.reports.map(function (c) {
                        return c.reportId;
                    }).indexOf(item.reportId);
                    this.reportParams.reports.splice(index, 1);
                    if (r) {
                        console.log('deleteReportClicked(...) >> response: ' + JSON.stringify(r));
                        this.refreshReportsList();
                        this._notificationsService.add(new Notification('success', 'Your report has been deleted successfully.'));
                    }
                },
                (error: any) => {
                    // console.error('deleteReportClicked(...) >> error:' + error);
                    this._errorHandler.processError(error);
                }

            );


    }



    openDeleteConfirmationModal(item: IReportItem) {
        let promptOptions: PromptOptions = { header: 'Delete Report', body: '' };
        $(".collapsible").collapsible({ accordion: true });
        $(".collapsible").collapsible({ accordion: false });
        $('.collapsible').collapsible('close', 0);

        promptOptions.body = 'Are you sure you want to delete the selected report?';
        this._prompt.openModal(null, true, promptOptions).first()
            .subscribe(
                answerIsYes => {
                    if (answerIsYes) {
                        this.deleteReportClicked(item);
                        this.collapseAll();
                    }
                });

        return false;
    }

    collapseAll(): void {
        $(".collapsible").collapsible({ accordion: true });
        $(".collapsible").collapsible({ accordion: false });
        $('.collapsible').collapsible('close', 0);
    }

    get IsMasterReport(): boolean {
        return this.reportParams.reportName == this.MASTER_REPORT_NAME || this.reportParams.reportName == this.MASTER_REFERENCE_REPORT_NAME
    }

    public onIncludeAllTagsChanged(yesPlease: boolean, force:boolean = false) {
        let tags = this.tagComponent.globalTags;
        if (yesPlease) {
            console.log('retrieving all tags pertaining in this criteria');
            if ((tags && tags.length == 0) || force) {
                this.loadTagLookups();
            }
            else{
                this.globalTags = tags;
            }
        }else{
            tags = [];
        }
        this.tagComponent.updateTags(tags);
    }
    public onCustomHeaderSelectionChanged(option:boolean)
    {
        if(option)
        {
            this.reportParams.asOfDate=(new Date()).toDateString();
            this.reportParams.customHeader=`Unless otherwise indicated, this status report addresses use in the film only.  Should any merchandise (books, toys, food products, video games, clothing, etc.) or product packaging be produced bearing items referenced here, additional review will be required.  When discussing status we will generally use the following terms with critical distinctions: \n \n Permissible -- Item has been assessed.  No permission is necessary as presently scripted and/or for currently proposed context. \n \n Clear -- Permission has been granted for use as currently scripted/proposed only. \n \n NOT CLEAR -- May not be used.`;
        }
        else{
            this.reportParams.asOfDate=null;
            this.reportParams.customHeader="";
        }
    }

    loadTagLookups(): void {
        var reportGenerateParams = this.getRequestParams();
        this._reportService.getTags(reportGenerateParams)
            .subscribe(
                (list) => {
                    if (list) {
                        this.onTagsRetrieved(list);
                    }
                },
                (error) => {
                    console.error('loadCILookups(...):' + error);
                }
            );

    }
    onTagsRetrieved(list: ILookup[]): void {
        console.log('list: ' + JSON.stringify(list));
        if (list) {
            this.globalTags = [];
            list.forEach(lookup => {
                var ciTag: CITag = new CITag();
                ciTag.tagId = lookup.id;
                ciTag.tagName = lookup.name;
                ciTag.tagType = lookup.type;
                ciTag.icon = 'bookmark';
                ciTag.isSelected = true;
                this.globalTags.push(ciTag);
            });

            // this.tagComponent.updateTagForm();
            this.tagComponent.updateTags(this.globalTags);
        }

    }

    newTagAdded(tag: FormGroup): void {
        if (tag) {
            tag.controls.isSelected.setValue(!tag.controls.isSelected.value);
        }
    }

    refreshParams(e){
        this.onIncludeAllTagsChanged(this.filterTagsCheck.nativeElement.checked, true)
    }

    setToolTipDelay(){
        const container = document.getElementById('cardListDivContainer');
        let self = this;
        if (container) {
            const divsSearchBy = container.querySelectorAll('.searchByToolTip');
            const divsSearchByArray = Array.from(divsSearchBy);
            divsSearchByArray.forEach((div: HTMLDivElement) => {
                let report = self.reportParams.reports.find(r => r.createdDate == (div.nextElementSibling.firstChild.nextSibling as HTMLDivElement).innerText);
                if (report){
                    report.toolTipSearchByDelay = 5000;
                    if ((div.scrollWidth > div.clientWidth)){
                        report.toolTipSearchByDelay = 500;
                    }
                }
                $('.searchByToolTip').tooltip();
            });
            const divsStatus = container.querySelectorAll('.statusToolTip');
            const divsStatusArray = Array.from(divsStatus);
            divsStatusArray.forEach((div: HTMLDivElement) => {
                let report = self.reportParams.reports.find(r => r.createdDate == (div.nextElementSibling.nextElementSibling.firstChild.nextSibling as HTMLDivElement).innerText);
                if (report){
                    report.toolTipStatusDelay = 5000;
                    if ((div.scrollWidth > div.clientWidth)){
                    report.toolTipStatusDelay = 500;
                    }
                }
                $('.statusToolTip').tooltip();
            });
        }
    }
    
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/reports/reports.component.ts